var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "category" },
    [
      !_vm.disabled
        ? _c("div", { staticClass: "pageTitle" }, [
            _c("span", { staticClass: "left" }, [
              _vm._v(" 分类页装修 - "),
              ["plat_custom", "custom"].includes(_vm.info.module)
                ? _c(
                    "span",
                    [
                      _vm._v(" " + _vm._s(_vm.info.customer_name) + " "),
                      _vm.info.customer_name.indexOf("*") != -1
                        ? _c(
                            "el-button",
                            {
                              staticStyle: {
                                padding: "0",
                                "margin-left": "8px",
                              },
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.watchCustomerName("1")
                                },
                              },
                            },
                            [_vm._v("查看")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(_vm.info.short_name || _vm.info.company_name) +
                        " " +
                        _vm._s(_vm.info.module === "admin" ? "(渠道)" : "") +
                        " "
                    ),
                  ]),
            ]),
            _c("div", { staticClass: "right" }, [
              _vm.$hasBtnRoles(
                {
                  admin: "/decoration/decoration/get-decoration-log",
                  custom: "/decoration/decoration/get-customer-decoration-log",
                  plat_custom: "/plat/decoration/get-customer-decoration-log",
                  channel: "/decoration/decoration/get-shop-decoration-log",
                }[_vm.info.module]
              )
                ? _c(
                    "span",
                    { staticClass: "log", on: { click: _vm.openLogDialog } },
                    [
                      _c("i", { staticClass: "el-icon el-icon-s-order" }),
                      _vm._v(" 操作日志 "),
                    ]
                  )
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c("category-basic", {
            ref: "categoryBasic",
            attrs: {
              styleId: _vm.style_id,
              info: _vm.info,
              disabled: _vm.disabled,
            },
            on: {
              onSave: _vm.saveBasic,
              onChangeMenuStyle: _vm.changeMenuStyle,
            },
            model: {
              value: _vm.formData,
              callback: function ($$v) {
                _vm.formData = $$v
              },
              expression: "formData",
            },
          }),
          _vm.showConfigArea
            ? _c("div", { staticClass: "center" }, [
                !_vm.disabled
                  ? _c(
                      "div",
                      { staticClass: "leftPanel" },
                      [
                        _vm.activeLeftData.value
                          ? [
                              _c(
                                "draggable",
                                {
                                  staticClass: "draggable",
                                  attrs: {
                                    animation: "500",
                                    "force-fallback": true,
                                    group: {
                                      name: "panelMove",
                                      pull: "clone",
                                      put: false,
                                    },
                                    sort: false,
                                    filter:
                                      "" +
                                      []
                                        .concat(_vm.leftFilterDomList)
                                        .map(function (key) {
                                          return "." + key
                                        })
                                        .toString(),
                                  },
                                  on: { end: _vm.moveEndPanel },
                                  model: {
                                    value: _vm.activeLeftData.value,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.activeLeftData, "value", $$v)
                                    },
                                    expression: "activeLeftData.value",
                                  },
                                },
                                _vm._l(
                                  _vm.activeLeftData.value,
                                  function (item, index) {
                                    return _c("mall", {
                                      key: item.key + "_" + index,
                                      class: ["model", item.key],
                                      attrs: {
                                        item: item,
                                        "type-id": _vm.interactionStyle,
                                      },
                                      on: { _addPanel: _vm.addPanel },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.addPanel(item)
                                        },
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ]
                          : _c("div", { staticClass: "noData" }, [
                              _vm._v("暂无数据"),
                            ]),
                      ],
                      2
                    )
                  : _vm._e(),
                _c("div", { staticClass: "contentWrap" }, [
                  _c("div", { staticClass: "contentTitle" }, [
                    _vm._v("分类页效果预览"),
                  ]),
                  _c("div", { ref: "content", staticClass: "content" }, [
                    _c(
                      "div",
                      {
                        ref: "phone",
                        staticClass: "phone",
                        attrs: { id: "phone" },
                      },
                      [
                        _c(
                          "draggable",
                          {
                            staticClass: "clearfix",
                            attrs: {
                              animation: "500",
                              group: "panelMove",
                              id: "draggableCenter",
                              "force-fallback": true,
                            },
                            on: {
                              start: _vm.handleStartRemove,
                              end: _vm.handleEndRemove,
                            },
                            model: {
                              value: _vm.layoutList,
                              callback: function ($$v) {
                                _vm.layoutList = $$v
                              },
                              expression: "layoutList",
                            },
                          },
                          [
                            _vm._l(_vm.layoutList, function (item, index) {
                              return [
                                _c(
                                  "div",
                                  {
                                    key: item.uid,
                                    class: [
                                      "plate-wrap",
                                      item.key,
                                      item.uid === _vm.configData.uid &&
                                        "current",
                                      item.error && "error",
                                    ],
                                    staticStyle: { "border-width": "1px" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.plateHandle(item)
                                      },
                                    },
                                  },
                                  [
                                    _c(_vm.previewComponent(item), {
                                      tag: "component",
                                      class: "empty_" + item.key,
                                      attrs: {
                                        value: item,
                                        themeColor: _vm.themeColor,
                                        styleId: _vm.style_id,
                                      },
                                    }),
                                    _c("i", {
                                      staticClass: "el-icon el-icon-close",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.removeLayout(item, index)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            }),
                          ],
                          2
                        ),
                        _vm.layoutList.length < 1
                          ? _c(
                              "div",
                              { staticClass: "add-plate" },
                              [
                                _vm.noPlate
                                  ? _c("div", [
                                      _vm._v("暂无板块，请去板块管理添加板块"),
                                    ])
                                  : [
                                      _c("span", { staticClass: "icon-add" }, [
                                        _vm._v("+"),
                                      ]),
                                      _c("span", [
                                        _vm._v("请从左侧添加功能板块"),
                                      ]),
                                    ],
                              ],
                              2
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  !_vm.disabled
                    ? _c("div", { staticClass: "tips" }, [
                        _vm._v("将组件拖出预览区即可删除"),
                      ])
                    : _vm._e(),
                ]),
                _c(
                  "div",
                  {
                    class: ["config", _vm.isEmpty(_vm.configData) && "noData"],
                  },
                  [
                    !_vm.isEmpty(_vm.configData)
                      ? [
                          _c("div", { staticClass: "header" }, [
                            _c("span", [_vm._v(_vm._s(_vm.panelTitle))]),
                            _c("i", {
                              staticClass: "el-icon el-icon-close",
                              on: { click: _vm.closeConfigPanel },
                            }),
                          ]),
                          _c(
                            "div",
                            { staticClass: "configContent" },
                            [
                              _c(_vm.configData.key + "_config", {
                                key: _vm.configData.uid,
                                ref: "config",
                                tag: "component",
                                staticClass: "configCom",
                                attrs: {
                                  styleId: _vm.style_id,
                                  info: _vm.info,
                                  disabled: _vm.disabled,
                                  menuList: _vm.menuList,
                                },
                                model: {
                                  value: _vm.configData,
                                  callback: function ($$v) {
                                    _vm.configData = $$v
                                  },
                                  expression: "configData",
                                },
                              }),
                              !_vm.disabled
                                ? _c(
                                    "div",
                                    { staticClass: "configBtns" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            loading: _vm.configLoading,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.saveConfig()
                                            },
                                          },
                                        },
                                        [_vm._v("保存")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ])
            : _vm._e(),
          !_vm.disabled
            ? _c(
                "div",
                { staticClass: "contentBtns" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.releaseLoading },
                      on: { click: _vm.release },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.showConfigArea ? "发布" : "保存") + " "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            top: "20px",
            width: "70%",
            title: "查看操作日志",
            "lock-scroll": "",
            visible: _vm.logShow,
          },
          on: {
            "update:visible": function ($event) {
              _vm.logShow = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c(
            "el-form",
            { ref: "logForm", attrs: { model: _vm.logForm, inline: "" } },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "operate_time", label: "操作时间" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "value-format": "yyyy-MM-dd",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                    },
                    model: {
                      value: _vm.logForm.operate_time,
                      callback: function ($$v) {
                        _vm.$set(_vm.logForm, "operate_time", $$v)
                      },
                      expression: "logForm.operate_time",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "operate_type", label: "操作类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.logForm.operate_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.logForm, "operate_type", $$v)
                        },
                        expression: "logForm.operate_type",
                      },
                    },
                    _vm._l(_vm.operateTypeList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "operator_id", label: "操作人" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.logForm.operator_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.logForm, "operator_id", $$v)
                        },
                        expression: "logForm.operator_id",
                      },
                    },
                    _vm._l(_vm.sellUserList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getLogData } },
                [_vm._v("搜索")]
              ),
              _c("el-button", { on: { click: _vm.resetForm } }, [
                _vm._v("重置"),
              ]),
            ],
            1
          ),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.logList,
                "header-cell-style": {
                  background: "#f1f1f1",
                  color: "#333333",
                },
                height: "60vh",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  width: "150px",
                  prop: "operator_name",
                  label: "操作人",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "170px",
                  prop: "create_time",
                  label: "操作时间",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "150px",
                  prop: "operate_type",
                  label: "操作类型",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.filterOperateType(scope.row.operate_type)
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "note",
                  "min-width": "300px",
                  label: "操作内容",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-top": "10px", "text-align": "right" } },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, prev, pager, next, jumper",
                  "current-page": _vm.logForm.page,
                  "page-size": _vm.logForm.page_size,
                  total: _vm.totalCount,
                },
                on: { "current-change": _vm.getLogData },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.logShow = false
                    },
                  },
                },
                [_vm._v(" 关闭 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }